import _extends from "@babel/runtime-corejs3/helpers/extends";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import { createElementVNode as _$ce, map as _$ma, className as _$cn, createUnknownComponentVNode as _$cc, createVNode as _$cv, noop as _$no, extend as _$ex, EMPTY_OBJ as _$em } from 'intact-vue-next';
import { eachChildren } from '../utils';
import { makeStyles } from './styles';
import { isStringOrNumber, isNull, isObject, EMPTY_OBJ } from 'intact-shared';
import { getClassAndStyleForFixed } from './useFixedColumns';
import { Affix } from '../affix';
import { TableRow } from './row';
import { Checkbox } from '../checkbox';
import { context as GroupContext } from './useGroup';
import { context as SortableContext } from './useSortable';
import { Spin } from '../spin';
import { Transition, TransitionGroup, createComponentVNode } from 'intact-vue-next';
import { _$ } from '../../i18n';
import { context as TableContext } from './useColumns';
import { expandAnimationCallbacks } from '../utils';
import { Tooltip } from '../tooltip';
import { AllCheckedStatus } from './useChecked';
import { context as ResizableContext } from './useResizable';
import { context as FixedColumnsContext } from './useFixedColumns';
import { Pagination } from '../pagination';
var _$tmp0 = {
  'width': '40'
};
export default function ($props, $blocks, $__proto__) {
  var _classNameObj,
    _this = this;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    data = _this$get.data,
    children = _this$get.children,
    className = _this$get.className,
    fixHeader = _this$get.fixHeader,
    checkType = _this$get.checkType,
    rowKey = _this$get.rowKey,
    type = _this$get.type,
    stripe = _this$get.stripe,
    rowClassName = _this$get.rowClassName,
    group = _this$get.group,
    sort = _sortInstanceProperty(_this$get),
    loading = _this$get.loading,
    merge = _this$get.merge,
    childrenKey = _this$get.childrenKey,
    indent = _this$get.indent,
    tooltipPosition = _this$get.tooltipPosition,
    tooltipContainer = _this$get.tooltipContainer,
    showIndeterminate = _this$get.showIndeterminate,
    resizable = _this$get.resizable,
    draggable = _this$get.draggable,
    _animation = _this$get.animation,
    hideHeader = _this$get.hideHeader,
    pagination = _this$get.pagination,
    fixFooter = _this$get.fixFooter;
  var animation = !Array.isArray(_animation) ? [_animation, _animation] : _animation;
  var _this$columns$getData = this.columns.getData(),
    columns = _this$columns$getData.columns,
    cols = _this$columns$getData.cols,
    maxRows = _this$columns$getData.maxRows,
    maxCols = _this$columns$getData.maxCols;
  var _this$fixedColumns = this.fixedColumns,
    scrollPosition = _this$fixedColumns.scrollPosition,
    hasFixed = _this$fixedColumns.hasFixed,
    getHasFixedLeft = _this$fixedColumns.getHasFixedLeft,
    offsetMap = _this$fixedColumns.offsetMap;
  var scrollRef = this.scroll.scrollRef;
  var _this$stickyHeader = this.stickyHeader,
    stickHeader = _this$stickyHeader.stickHeader,
    excludeStickHeader = _this$stickyHeader.excludeStickHeader,
    elementRef = _this$stickyHeader.elementRef,
    headRef = _this$stickyHeader.headRef;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-table"] = true, _classNameObj[k + "-fix-header"] = fixHeader, _classNameObj[k + "-fix-footer"] = fixFooter, _classNameObj[k + "-scroll-" + scrollPosition.value] = scrollPosition.value, _classNameObj[k + "-fix-columns"] = hasFixed.value, _classNameObj[k + "-" + type] = type && type !== 'default', _classNameObj[k + "-stripe"] = stripe, _classNameObj[k + "-with-expand"] = $blocks.expand, _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var style = isStringOrNumber(fixHeader) ? {
    maxHeight: fixHeader + "px"
  } : null;
  var _this$width = this.width,
    getWidth = _this$width.getWidth,
    tableRef = _this$width.tableRef,
    tableWidth = _this$width.tableWidth;
  var onStart = this.resizable.start;
  var colgroup = _$ce(2, 'colgroup', [checkType !== 'none' ? _$ce(2, 'col', null, 1, null, _$tmp0) : undefined, _$ma(cols, function ($value, $key) {
    var _$cn2;
    return _$ce(2, 'col', null, 1, _$cn((_$cn2 = {}, _$cn2[k + "-hidden"] = $value.hidden, _$cn2[$value.className] = $value.className, _$cn2)), {
      'width': $value.width,
      'style': {
        width: getWidth($value.key)
      }
    });
  }, $this)], 0);
  var hasData = data && data.length;
  var hasFixedLeft = getHasFixedLeft();
  var _this$checked = this.checked,
    getAllCheckedStatus = _this$checked.getAllCheckedStatus,
    toggleCheckedAll = _this$checked.toggleCheckedAll,
    getAllStatus = _this$checked.getAllStatus,
    onChangeChecked = _this$checked.onChangeChecked;
  var allCheckedStatus = getAllCheckedStatus();
  var thead = hideHeader ? null : _$cc(TableContext.Provider, {
    'value': checkType,
    'children': _$cc(GroupContext.Provider, {
      'value': {
        group: group,
        onChange: this.onChangeGroup
      },
      'children': _$cc(SortableContext.Provider, {
        'value': {
          sort: sort,
          onChange: this.sortable.onChange
        },
        'children': _$cc(ResizableContext.Provider, {
          'value': {
            resizable: resizable,
            onStart: onStart
          },
          'children': _$cc(FixedColumnsContext.Provider, {
            'value': offsetMap.value,
            'children': _$ce(2, 'thead', _$ma(columns, function ($value, $key) {
              return _$ce(2, 'tr', function () {
                var ths = [$key === 0 && checkType !== 'none' ? _$cv('th', _extends({}, getClassAndStyleForFixed({
                  fixed: hasFixedLeft ? 'left' : false
                }, 0, k), {
                  'rowspan': maxRows,
                  'key': '$checktype'
                }), checkType === 'checkbox' ? _$cc(Checkbox, {
                  'value': allCheckedStatus === AllCheckedStatus.All,
                  'indeterminate': showIndeterminate && allCheckedStatus == AllCheckedStatus.Indeterminate,
                  'ev-$change:value': toggleCheckedAll,
                  'disabled': !hasData
                }) : undefined) : undefined, $value];
                return animation[1] ? _$cc(TransitionGroup, {
                  'name': 'k-fade-expand',
                  'move': false,
                  'children': ths
                }) : ths;
              }(), 0);
            }, $this), 4)
          })
        })
      })
    })
  });
  var getAllKeys = this.disableRow.getAllKeys;
  var getGrid = this.merge.getGrid;
  var allStatus = getAllStatus();
  var allKeys = getAllKeys();
  var colCount = maxCols + (checkType !== 'none' ? 1 : 0);
  var isExpanded = this.expandable.isExpanded;
  var isSelected = this.selected.isSelected;
  var _this$tree = this.tree,
    loopData = _this$tree.loopData,
    isSpreaded = _this$tree.isSpreaded,
    toggleSpreadRow = _this$tree.toggleSpreadRow;
  var _this$draggable = this.draggable,
    onRowDragStart = _this$draggable.onRowDragStart,
    onRowDragOver = _this$draggable.onRowDragOver,
    onRowDragEnd = _this$draggable.onRowDragEnd,
    draggingKey = _this$draggable.draggingKey;
  var tbody = _$ce(2, 'tbody', !hasData ? _$ce(2, 'tr', _$ce(2, 'td', (_$blocks['empty'] = function ($super) {
    return _$('暂无数据');
  }, __$blocks['empty'] = function ($super, data) {
    var block = $blocks['empty'];
    var callBlock = function callBlock() {
      return _$blocks['empty'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['empty'](_$no)), 0, _$cn(k + "-table-empty"), {
    'colspan': colCount
  }), 2, null, null, 'table-empty') : function () {
    var rows = [];
    loopData(function (value, index, level, hidden) {
      // don't render if row is hidden
      if (hidden) return hidden;
      var status = allStatus[index];
      var key = allKeys[index];
      var spreaded = isSpreaded(key);
      var hasChildren = !!childrenKey && Array.isArray(value[childrenKey]);
      var indentSize = indent ? indent * level : 0;
      var row = _$cc(TableRow, {
        'key': key,
        'cols': cols,
        'data': value,
        'loaded': value.loaded,
        'checkType': checkType,
        'hasFixedLeft': hasFixedLeft,
        'onClick': _this.clickRow,
        'checked': status.checked,
        'indeterminate': status.indeterminate,
        'index': index,
        'disabled': status.disabled,
        'allDisabled': status.allDisabled,
        'className': _$cn(rowClassName && rowClassName(value, index, key)),
        'merge': merge,
        'grid': getGrid(),
        'onChangeChecked': onChangeChecked,
        'selected': isSelected(key),
        'spreaded': spreaded,
        'hasChildren': hasChildren,
        'indent': indentSize,
        'onToggleSpreadRow': toggleSpreadRow,
        'onBeforeUnmount': _this.resetRowStatus.onRowBeforeUnmount,
        'offsetMap': offsetMap.value,
        'animation': animation[1],
        'draggable': draggable,
        'draggingKey': draggingKey.value,
        'onRowDragStart': onRowDragStart,
        'onRowDragEnd': onRowDragEnd,
        'onRowDragOver': onRowDragOver
      }, key);
      if ($blocks.tooltip) {
        var content = (_$blocks['tooltip'] = function ($super) {
          return null;
        }, __$blocks['tooltip'] = function ($super, data) {
          var block = $blocks['tooltip'];
          var callBlock = function callBlock() {
            return _$blocks['tooltip'].call($this, $super, data);
          };
          return block ? block.call($this, callBlock, data) : callBlock();
        }, __$blocks['tooltip'](_$no, [value, index]));
        row = _$cc(Tooltip, {
          'key': key,
          'position': tooltipPosition,
          'container': tooltipContainer,
          'children': row,
          '$blocks': function ($blocks) {
            var _$blocks = {},
              __$blocks = _$ex({}, $blocks);
            return (_$blocks['content'] = function ($super) {
              return content;
            }, __$blocks['content'] = function ($super, data) {
              var block = $blocks['content'];
              var callBlock = function callBlock() {
                return _$blocks['content'].call($this, $super, data);
              };
              return block ? block.call($this, callBlock, data) : callBlock();
            }), __$blocks;
          }.call($this, _$em)
        }, key);
      }
      rows.push(row);
      if ($blocks.expand) {
        var _$cn3;
        var expanded = isExpanded(key);
        rows.push(_$ce(2, 'tr', _$ce(2, 'td', _$cc(Transition, _extends({}, expandAnimationCallbacks, {
          'children': expanded ? _$ce(2, 'div', (_$blocks['expand'] = function ($super) {
            return null;
          }, __$blocks['expand'] = function ($super, data) {
            var block = $blocks['expand'];
            var callBlock = function callBlock() {
              return _$blocks['expand'].call($this, $super, data);
            };
            return block ? block.call($this, callBlock, data) : callBlock();
          }, __$blocks['expand'](_$no, [value, index])), 0, _$cn(k + "-table-expand")) : undefined
        })), 2, null, {
          'colspan': colCount
        }), 2, _$cn((_$cn3 = {}, _$cn3[k + "-expand"] = true, _$cn3[k + "-expanded"] = expanded, _$cn3)), null, key + ".$expand"));
      }
      return hidden || !spreaded;
    });
    return animation[0] ? _$cc(TransitionGroup, {
      'name': 'k-fade-in-left',
      'move': !draggingKey.value,
      'children': rows
    }) : rows;
  }(), 0);
  var tfooter = null;
  if ($blocks.footer) {
    tfooter = _$ce(2, 'tfoot', _$ce(2, 'tr', _$ce(2, 'td', (_$blocks['footer'] = function ($super) {
      return null;
    }, __$blocks['footer'] = function ($super, data) {
      var block = $blocks['footer'];
      var callBlock = function callBlock() {
        return _$blocks['footer'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, __$blocks['footer'](_$no)), 0, _$cn(k + "-table-footer"), {
      'colspan': colCount
    }), 2, null, null, 'table-footer'), 2);
  }
  var tableWidthPx = tableWidth.value ? tableWidth.value + "px" : null;
  var _this$stickyScrollbar = this.stickyScrollbar,
    shouldStickScrollbar = _this$stickyScrollbar.shouldStickScrollbar,
    stickScrollbar = _this$stickyScrollbar.stick,
    stickScrollbarStyle = _this$stickyScrollbar.style,
    scrollbarRef = _this$stickyScrollbar.scrollbarRef,
    onScrollbarScroll = _this$stickyScrollbar.onScroll,
    tableActualWidth = _this$stickyScrollbar.tableActualWidth;
  var _this$pagination = this.pagination,
    pageValue = _this$pagination.value,
    pageLimit = _this$pagination.limit,
    onPageChange = _this$pagination.onChange,
    paginationRef = _this$pagination.paginationRef;
  return _$ce(2, 'div', [_$ce(2, 'div', [!isNull(stickHeader.value) ? _$cc(Affix, {
    'top': stickHeader.value,
    'exclude': excludeStickHeader,
    'className': _$cn(k + "-table-affix-header"),
    'children': _$ce(2, 'table', [colgroup, thead], 0, null, {
      'style': {
        width: tableWidthPx
      }
    }, null, headRef)
  }) : undefined, _$ce(2, 'table', [colgroup, isNull(stickHeader.value) ? thead : undefined, tbody, $blocks.footer ? tfooter : undefined], 0, null, {
    'style': {
      width: tableWidthPx
    }
  }, null, tableRef)], 0, _$cn(k + "-table-wrapper"), {
    'style': style
  }, null, scrollRef), pagination ? _$cc(Pagination, _extends({
    'ref': paginationRef,
    'total': data ? data.length : 0,
    'size': 'small'
  }, isObject(pagination) ? pagination : EMPTY_OBJ, {
    'value': pageValue.value,
    'limit': pageLimit.value,
    'ev-change': onPageChange
  }), null, paginationRef) : undefined, _$cc(Transition, {
    'name': 'k-fade',
    'children': loading ? _$cc(Spin, {
      'overlay': true,
      'size': 'small',
      'className': _$cn(k + "-table-spin")
    }) : undefined
  }), !isNull(stickScrollbar.value) ? _$cc(Affix, {
    'bottom': stickScrollbar.value,
    'shouldFix': shouldStickScrollbar,
    'style': stickScrollbarStyle.value,
    'children': _$ce(2, 'div', _$ce(2, 'div', null, 1, _$cn(k + "-table-scrollbar-inner"), {
      'style': {
        width: tableActualWidth.value
      }
    }), 2, _$cn(k + "-table-scrollbar"), {
      'ev-scroll': onScrollbarScroll
    }, null, scrollbarRef)
  }) : undefined], 0, _$cn(classNameObj), null, null, elementRef);
}
;